<template>
  <div class="corpo-pagina">

    <!-- TITOLO -->
    <div class="row">
      <div class="col s12">
        <h4>{{ !isNew ? translation('btn.menu.event.modify') : translation('title.page.new.event') }}</h4>
      </div>
    </div>

    <div class="divider"></div>

    <!-- NOME — TIPO — SPAZIO -->
    <div class="row">

      <!-- EVENT NAME -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">event</i>
          <input type="text"
                 v-model="evetnModel.name"
                 id="name"
                 class="validate required"
                 autocomplete="off" />
          <label for="name">{{ translation('event.name.field') }}</label>
          <span class="error-message-style nodisplay" id="error-message-name">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

      <div class="col s12 m2 l2"></div>

      <!-- EVENT TYPE -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix" id="select-icon-event_type_id">settings_applications</i>

     <select id="event_type_id"
        v-model="evetnModel.event_type_id"
        class="icons required">
          <option value="" disabled>
            {{ translation('filed.select.one') }}
          </option>

          <option v-for="r in typeList"
                  :key="r.id"
                  :value="r.id"
                  :data-icon="dataIcon(r.logo)"
                  class="img-type-select">
            {{ r.name }}
          </option>
        </select>

          <label for="event_type_id">{{ translation('event.type.field') }}</label>
          <span class="error-message-style nodisplay" id="error-message-event_type_id">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

    </div>

    <!-- DATE START — DATE END -->
    <div class="row">

      <!-- DATE START -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">today</i>
          <input id="date_start"
                 type="text"
                 class="datepicker required"
                 v-model="evetnModel.event_date_start"
                 autocomplete="off" />
          <label for="date_start">{{ translation('event.date.field') }}</label>
          <span class="error-message-style nodisplay" id="error-message-date_start">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

      <div class="col s12 m2 l2"></div>
      <!-- DATE END -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">today</i>
          <input id="date_finish"
                 type="text"
                 class="datepicker required"
                 v-model="evetnModel.event_date_finish"
                 autocomplete="off" />
          <label for="date_finish">{{ translation('event.date.field.finish') }}</label>
          <span class="error-message-style nodisplay" id="error-message-date_finish">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

    </div>

    <!-- LOCATION — TIMEZONE -->
    <div class="row">

      <!-- LOCATION -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">pin_drop</i>
          <input id="location"
                 type="text"
                 v-model="evetnModel.location"
                 class="validate required"
                 autocomplete="off" />
          <label for="location">{{ translation('location.event.field') }}</label>
          <span class="error-message-style nodisplay" id="error-message-location">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>
      <div class="col s12 m2 l2"></div>

      <!-- TIMEZONE -->
      <div class="col s12 m5 l5">
        <div class="input-field" style="width: 100%!important;">
          <i class="material-icons prefix">language</i>

          <select id="timezone_id"
                  v-model="evetnModel.timezone_id"
                  class="required">
            <option value="" disabled>
              {{ translation('filed.select.one') }}
            </option>
            <option v-for="r in timeList"
                    :key="r.uid"
                    :value="r.uid">
              {{ r.name }}
            </option>
          </select>

          <label for="timezone_id">{{ translation('time.zone.event.field') }}</label>
          <span class="error-message-style nodisplay" id="error-message-timezone_id">
            {{ translation('filed.required.validation') }}
          </span>
        </div>
      </div>

    </div>

    <!-- MAILER CHOICE -->
    <div class="row">
      <div class="col s12 m6">

        <div class="option-block z-depth-1">

          <div class="option-icon red-text">
            <i class="material-icons">email</i>
          </div>

          <div class="option-text">
            {{ translation('checkbox.sender.choise') }}
          </div>

          <div class="option-radios">
            <label>
              <input type="radio"
                     class="with-gap"
                     value="0"
                     v-model="evetnModel.withmailer"
                     @change="onChangeSender(0)" />
              <span>{{ translation('option.yes') }}</span>
            </label>

            <label style="margin-left: 25px;">
              <input type="radio"
                     class="with-gap"
                     value="1"
                     v-model="evetnModel.withmailer"
                     @change="onChangeSender(1)" />
              <span>{{ translation('option.no') }}</span>
            </label>
          </div>

        </div>

      </div>
    </div>

    <!-- SAVE BUTTON -->
    <div class="row">
      <div class="col s12">
        <a id="saveevent"
           class="btn-large red"
           href="javascript:void(0)"
           @click="saveNext">
          <i class="material-icons left">save</i>
          {{ !isNew ? translation('btn.menu.event.modify') : translation('bt.create.event.save.next') }}
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import { evetnModel } from '@/models/eventModel.js'
import countriesStore from '@/store/countries'
import translationStore from '@/store/translations'
import useAuthStore from '@/store/authStore.js'
import eventSetting from '@/store/eventSettings.js'
import M from 'materialize-css'
import apiService from '@/services/apiService.js'
import loadingStore from '@/store/loading'
import toast from '@/services/toast.js'

export default {
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    isBack: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      eventSetting: eventSetting,
      contries: countriesStore,
      useAuthStore: useAuthStore,
      evetnModel: { ...evetnModel }, // Crea una copia per evitare modifiche dirette allo store
      translationStore: translationStore,
      message_mail: { title: '', message: '', subject: '', btn: '' },
      toast: toast
    }
  },

  computed: {
    translation () {
      return this.translationStore.getters.traduzione
    },
    typeList () {
      return this.eventSetting.getters.type
    },
    timeList () {
      return this.contries.getters.timezones
    }
  },
  methods: {
    findTypeById (idToSearch) {
      return this.eventSetting.getters.type.find(item => item.id === idToSearch)
    },

    findTimezoById (idToSearch) {
      const t = Object.values(this.contries.getters.timezones)
      return t.find(item => item.uid === idToSearch)
    },

    dataIcon (logo) {
      return process.env.VUE_APP_URL_AWS_SMALL + '/' + logo
    },

    async populateTypEvent () {
      if (!eventSetting.getters.typeUploded) {
        try {
          const token = await apiService.getClientCredentialsToken()
          if (!token) {
            this.$router.push('/error')
            return // Esci se il token non è disponibile
          }
          const url = process.env.VUE_APP_URL_EVENTS + '/typeevents/list'
          const jsonTypeEvent = await apiService.sendRequestWithBearer('GET', url, token)
          if (!jsonTypeEvent) {
            this.$router.push('/error')
            return // Esci se la risposta è vuota
          }
          eventSetting.dispatch('caricaType', jsonTypeEvent)
        } catch (error) {
          this.$router.push('/error')
        }
      }
    },
    async populateSelect () {
      if (!countriesStore.getters.countrisUploded) {
        try {
          const token = await apiService.getClientCredentialsToken()
          if (!token) {
            this.$router.push('/error')
            return // Esci se il token non è disponibile
          }
          const url = process.env.VUE_APP_URL_USER + '/countries/all'
          const jsonCntry = await apiService.sendRequestWithBearer('GET', url, token)
          if (!jsonCntry) {
            this.$router.push('/error')
            return // Esci se la risposta è vuota
          }
          countriesStore.dispatch('caricaNazioni', jsonCntry)
        } catch (error) {
          this.$router.push('/error')
        }
      }
    },

    async getActualTime () {
      // Questo metodo imposta il timezone_id per i NUOVI eventi
      // Per gli eventi esistenti, timezone_id viene popolato dal watcher di timeList
      if (this.isNew && this.useAuthStore.getters.timezone) {
        this.evetnModel.timezone_id = this.useAuthStore.getters.timezone.uid
      }
      // Non è più necessario chiamare init qui, i watcher si occuperanno di questo.
    },

    blocForm (fields) {
      const allElements = document.querySelectorAll('*')
      const msgElements = document.querySelectorAll('.error-message-style')

      allElements.forEach(element => {
        if (element.classList.contains('invalid')) {
          element.classList.remove('invalid')
        }
        if (element.classList.contains('invalid-icon')) {
          element.classList.remove('invalid-icon')
        }
      })

      msgElements.forEach(element => {
        element.classList.add('nodipslay')
      })

      Object.values(fields).forEach(valore => {
        const elem = document.getElementById(valore.field)

        if (elem && this.isVisibleComputedStyle(elem)) {
          elem.classList.add('invalid')
          const prefixIcon = elem.previousElementSibling

          // Gestione specifica per gli elementi <select> di Materialize
          if (elem.tagName.toLowerCase() === 'select') {
            const selectWrapper = elem.parentNode.querySelector('.select-wrapper input.select-dropdown')
            if (selectWrapper) {
              selectWrapper.classList.add('invalid')

              const iconInvalid = document.getElementById('select-icon-' + valore.field)
              if (iconInvalid) iconInvalid.classList.add('invalid-icon')
            }
          }

          if (prefixIcon && prefixIcon.classList.contains('prefix')) {
            prefixIcon.classList.add('invalid-icon')
          }

          const msg = document.getElementById('error-message-' + valore.field)
          if (msg) {
            msg.classList.remove('nodipslay')
          }
        }
      })
    },

    async validateForm () {
      const fields = []
      let ris = true
      const required = document.querySelectorAll('.required')

      for (let i = 0; i < required.length; i++) {
        const el = required[i]
        const filedName = el.getAttribute('id')
        const val = el.value
        let err = this.$validateRequired(val)

        if (filedName === 'email') {
          err = this.$validateEmail(val)
        }

        if (!err) {
          fields.push({ field: filedName })
        }
      }

      const lvalid = fields.length
      if (lvalid >= 1) {
        ris = false
        this.blocForm(fields)
      }
      return ris
    },
    onChange (code) {
      this.evetnModel.has_table = code === 0
    },
    onChangeSender (code) {
      this.evetnModel.has_mailer = code === 0
    },

    async saveNext () {
      let msg = this.translation('pagina.event.modifica.ok')

      loadingStore.commit('setLoading', true)
      const valid = await this.validateForm()

      if (valid) {
        const token = await apiService.getClientCredentialsToken()

        if (!token) {
          this.$router.push('/error')
          loadingStore.commit('setLoading', false)
          return
        }

        let url = process.env.VUE_APP_URL_EVENTS

        if (this.isNew) {
          url += '/events/create'
          delete this.evetnModel.id
          delete this.evetnModel.uid
        } else {
          url += '/events/modify'
          // this.evetnModel.id = eventSetting.getters.idEvent
          // this.evetnModel.uid = eventSetting.getters.uidEvent
        }

        // Assicurati che event_type e timezone siano oggetti completi se il backend se li aspetta
        this.evetnModel.event_type = this.findTypeById(this.evetnModel.event_type_id)
        this.evetnModel.timezone = this.findTimezoById(this.evetnModel.timezone_id)
        this.evetnModel.user.email = this.useAuthStore.getters.userInfo.email
        this.evetnModel.user.uid = this.useAuthStore.getters.userInfo.uid
        this.evetnModel.logo = this.evetnModel.event_type.logo // Aggiunto controllo null

        const jsonRes = await apiService.sendRequestWithBearer('POST', url, token, this.evetnModel)

        if (!jsonRes) {
          this.$router.push('/error') // Gestione errore generica
        } else {
          if (jsonRes.error) {
            const fields = []
            const required = jsonRes.details
            for (let i = 0; i < required.length; i++) {
              const el = required[i]
              const filedName = el.defaultMessage
              fields.push({ field: filedName })
            }
            this.blocForm(fields)
            loadingStore.commit('setLoading', false)
            return // Ferma l'esecuzione se ci sono errori di validazione dal backend
          }

          eventSetting.dispatch('setModel', jsonRes)
          if (this.isNew || this.isBack) {
            msg = this.translation('pagina.event.creazione.ok')
            this.toast.createStampToast('thumb_up', msg, 'toast-green')

            this.$router.push('/new-event-step2')
          }
        }
      }
      loadingStore.commit('setLoading', false)
    },
    isVisibleComputedStyle (element) {
      const style = window.getComputedStyle(element)
      return style.display !== 'none' && style.visibility !== 'hidden'
    },

    // Metodo per inizializzare SOLO Datepicker
    initMaterializeDatepickers () {
      this.$nextTick(() => {
        const timezone = this.useAuthStore.getters.timezone
        const timeFormat = timezone && timezone.time_format ? timezone.time_format : 'HH:mm'
        const optform = timeFormat.split(' ')
        const format = optform[0]

        const initDatepicker = (elementId, modelProp) => {
          const el = document.getElementById(elementId)
          if (!el) return

          const instance = M.Datepicker.getInstance(el)
          if (instance) {
            instance.destroy()
          }

          const datepickerOptions = {
            // ... (tutte le tue opzioni i18n restano uguali)
            autoClose: true,
            format: format.toLowerCase(),
            onSelect: (selectedDate) => {
              if (el.id === 'date_start') {
                this.evetnModel.formatLocalISO(selectedDate)

                // --- LOGICA DI COLLEGAMENTO ---
                // Recuperiamo l'istanza del picker di fine
                const finishEl = document.getElementById('date_finish')
                const finishInstance = M.Datepicker.getInstance(finishEl)

                if (finishInstance) {
                  // Impostiamo la data minima per il secondo picker
                  finishInstance.options.minDate = selectedDate

                  // Se la data di fine già selezionata è prima della nuova data d'inizio, resettala
                  if (finishInstance.date && finishInstance.date < selectedDate) {
                    this.evetnModel.event_date_finish = ''
                    finishInstance.setDate(null)
                  }
                }
                // ------------------------------
              }

              const formattedDate = M.Datepicker.getInstance(el).toString()
              this.$nextTick(() => {
                this.evetnModel[modelProp] = formattedDate
              })
            },
            onClose: () => {
              M.updateTextFields()
            }
          }

          M.Datepicker.init(el, datepickerOptions)

          // ... (resto del codice per il setDate iniziale)
        }

        // Importante: inizializziamo prima 'date_finish' o assicuriamoci
        // che esistano entrambi prima che 'onSelect' possa essere triggerato
        initDatepicker('date_finish', 'event_date_finish')
        initDatepicker('date_start', 'event_date_start')

        // --- LOGICA PER LO STATO INIZIALE ---
        // Se al caricamento hai già una data d'inizio, impostala come minDate per la fine
        const startEl = document.getElementById('date_start')
        const finishEl = document.getElementById('date_finish')
        const startInst = M.Datepicker.getInstance(startEl)
        const finishInst = M.Datepicker.getInstance(finishEl)

        if (startInst && startInst.date && finishInst) {
          finishInst.options.minDate = startInst.date
        }
      })
    },

    // Metodo per inizializzare SOLO le Select di Materialize
    initMaterializeSelects () {
      this.$nextTick(() => {
        const selectElements = document.querySelectorAll('select')
        if (M && M.FormSelect) {
          selectElements.forEach(selectEl => {
            const instance = M.FormSelect.getInstance(selectEl)
            if (instance) {
              instance.destroy()
            }
            M.FormSelect.init(selectEl, {
              classes: 'icon-typevent-select'
            })

            // Assicurati che l'input visibile di Materialize mostri il valore corretto
            if (selectEl.value && M.FormSelect.getInstance(selectEl)) {
              const selectedOptionText = selectEl.options[selectEl.selectedIndex] ? selectEl.options[selectEl.selectedIndex].textContent : ''
              M.FormSelect.getInstance(selectEl).input.value = selectedOptionText
            }
          })
        }
      })
    },

    // Metodo per inizializzare tutti i componenti Materialize
    initAllMaterializeForms () {
      this.initMaterializeDatepickers()
      this.initMaterializeSelects()
    }
  },
  watch: {
    'translationStore.getters.linguaCorrente': {
      handler () {
        this.initAllMaterializeForms() // Re-inizializza tutto quando cambia lingua
      },
      immediate: true
    },
    typeList: {
      handler (newVal) {
        if (newVal && newVal.length > 0) {
          // Se stiamo modificando un evento e typeList si è caricato, imposta event_type_id
          if (!this.isNew && eventSetting.getters.eventModel.event_type) {
            this.evetnModel.event_type_id = eventSetting.getters.eventModel.event_type.id
          }
          this.initMaterializeSelects() // Inizializza le select dopo che le opzioni sono disponibili
        }
      },
      deep: true // Necessario per rilevare cambiamenti all'interno dell'array
    },
    timeList: {
      handler (newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // Se stiamo modificando un evento e timeList si è caricato, imposta timezone_id
          if (!this.isNew && eventSetting.getters.eventModel.timezone) {
            this.evetnModel.timezone_id = eventSetting.getters.eventModel.timezone.uid
          }
          this.initMaterializeSelects() // Inizializza le select dopo che le opzioni sono disponibili
          this.initMaterializeDatepickers() // Re-inizializza datepicker se il formato dipende da timezone
        }
      },
      deep: true
    },
    // Watcher specifici per gli ID delle select. Essenziali per aggiornare Materialize
    // quando il v-model imposta i valori iniziali da `evetnModel.buildata` o i watcher.
    'evetnModel.event_type_id': {
      handler (newVal) {
        // Chiama initMaterializeSelects solo se newVal non è null/undefined
        // e se typeList è già popolato, altrimenti non ci sono opzioni da selezionare
        if (newVal && this.typeList && this.typeList.length > 0) {
          this.initMaterializeSelects()
        }
      }
    },
    'evetnModel.timezone_id': {
      handler (newVal) {
        // Chiama initMaterializeSelects solo se newVal non è null/undefined
        // e se timeList è già popolato.
        if (newVal && this.timeList && Object.keys(this.timeList).length > 0) {
          this.initMaterializeSelects()
          // Re-inizializza i datepicker se il formato della data dipende dal fuso orario
          this.initMaterializeDatepickers()
        }
      }
    }
  },

  async mounted () {
    // Mostra il loading all'inizio del mounted
    loadingStore.commit('setLoading', true)

    // 1. Carica prima i dati necessari per le select
    await this.populateSelect() // Popola timeList
    await this.populateTypEvent() // Popola typeList

    // 2. Se è una modifica, popola evetnModel con i dati dell'evento esistente
    if (!this.isNew) {
      // Clona e assegna i dati dell'evento per renderli reattivi
      // Assicurati che eventModel abbia le proprietà dirette come event_type e timezone
      this.evetnModel.buildata(eventSetting.getters.eventModel)
    }

    // 3. Ottieni il fuso orario per l'inizializzazione (utile per nuovi eventi)
    await this.getActualTime()

    // 4. Inizializza tutti i componenti Materialize dopo che i dati sono stati caricati
    // e i v-model sono stati potenzialmente aggiornati.
    // I watcher gestiranno le successive inizializzazioni.
    await this.$nextTick(() => {
      this.initAllMaterializeForms()
      M.updateTextFields() // Aggiorna le label degli input
    })

    // Nascondi il loading alla fine del mounted
    loadingStore.commit('setLoading', false)
  },
  created () {
    // Potrebbe essere chiamato anche qui se il componente non è in cache
    // ma mounted è il posto più sicuro per la logica di inizializzazione DOM-related
  },
  // Aggiungi un metodo per pulire le istanze Materialize se il componente viene distrutto
  beforeDestroy () {
    // Distruggi le istanze Materialize per prevenire memory leak
    const selectElements = document.querySelectorAll('select')
    selectElements.forEach(selectEl => {
      const instance = M.FormSelect.getInstance(selectEl)
      if (instance) {
        instance.destroy()
      }
    })
    const datepickerElements = document.querySelectorAll('.datepicker')
    datepickerElements.forEach(datepickerEl => {
      const instance = M.Datepicker.getInstance(datepickerEl)
      if (instance) {
        instance.destroy()
      }
    })
  }
}
</script>

<style scoped>

.nodisplay {
  display: none !important;
}

.option-block {
  padding: 15px;
  border-radius: 8px;
  background: #fafafa;
  display: flex;
  align-items: center;
  width: 83%;
}

.option-icon i {
  font-size: 32px;
  margin-right: 15px;
}

.option-text {
  flex-grow: 1;
  font-weight: 600;
}

.option-radios label {
  margin-right: 10px;
}
.img-type-select {
  display: flex;
  align-items: center;
}

.select-wrapper .caret {
  fill: black;
}
</style>
